import { Grid } from '@mui/material';
import React from 'react';
import { AnimatedBar } from './AnimatedBar';

interface DeliveryProgressBarProps {
    stage?: 0 | 1 | 2 | 3 | 4 | 5;
}

const barsArray = Array.from({ length: 5 }, (_, i) => i);

export const DeliveryProgressBar: React.FC<DeliveryProgressBarProps> = ({ stage = 0 }) => {
    const renderBar = React.useCallback(
        (i: number) => (
            <Grid key={`progress-${i}`} size={2} sx={{ my: 2 }}>
                <AnimatedBar filled={stage > i} active={stage === i} />
            </Grid>
        ),
        [stage]
    );
    return (
        <Grid width="100%" container columns={10} spacing={1}>
            {barsArray.map(renderBar)}
        </Grid>
    );
};
